import {jsxs as _jsxs, jsx as _jsx} from "react/jsx-runtime";import styled from '@emotion/styled'
import * as React from 'react'
import {Component} from 'react'
import {PALETTE} from '../../styles/paletteV3'
import ui from '../../styles/ui'

const Base = styled('label')({
  alignItems: 'center',
  color: PALETTE.SLATE_700,
  display: 'flex',
  fontSize: ui.fieldSizeStyles.medium.fontSize,
  lineHeight: ui.fieldSizeStyles.medium.lineHeight,
  paddingBottom: ui.controlBlockPaddingVertical.medium,
  paddingTop: ui.controlBlockPaddingVertical.medium,
  paddingLeft: ui.controlBlockPaddingHorizontal.medium
})

const Input = styled('input')({
  order: 2
})

const Label = styled('div')({
  order: 3,
  paddingLeft: '.5rem'
})









class Radio extends Component {
  render() {
    // foce checked to a boolean again because of react bug
    const {checked, name, onChange, label, value} = this.props
    return (
      _jsxs(Base, { children: [
        _jsx(Input, { name: name, type: "radio", checked: !!checked, value: value, onChange: onChange,} )
        , _jsx(Label, { children: label})
      ]})
    )
  }
}

export default Radio
